var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorrowingCapacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17188 5.11V46.89C5.17188 49.16 7.01187 51 9.28187 51H42.7219C44.9919 51 46.8319 49.16 46.8319 46.89V5.11C46.8319 2.84 44.9919 1 42.7219 1H9.28187C7.01187 1 5.17188 2.84 5.17188 5.11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17188 5.12V46.88C5.17188 49.15 7.01187 51 9.29187 51H42.7219C44.9919 51 46.8419 49.16 46.8419 46.88V5.12C46.8419 2.85 45.0019 1 42.7219 1H9.29187C7.01187 1 5.17188 2.84 5.17188 5.12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8214 7.47998H11.1914V16.74H40.8214V7.47998Z",
    fill: "#FFCF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8214 7.47998H11.1914V16.74H40.8214V7.47998Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7514 24.5601H11.1914V30.1201H16.7514V24.5601Z",
    fill: "#FFCF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8217 24.5601H35.2617V30.1201H40.8217V24.5601Z",
    fill: "#FFCF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7827 24.5601H23.2227V30.1201H28.7827V24.5601Z",
    fill: "#FFCF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7514 36.61H11.1914V42.17H16.7514V36.61Z",
    fill: "#FFCF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8217 36.61H35.2617V42.17H40.8217V36.61Z",
    fill: "#FFCF00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7514 24.5601H11.1914V30.1201H16.7514V24.5601Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8217 24.5601H35.2617V30.1201H40.8217V24.5601Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7827 24.5601H23.2227V30.1201H28.7827V24.5601Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7514 36.61H11.1914V42.17H16.7514V36.61Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8217 36.61H35.2617V42.17H40.8217V36.61Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7827 36.61H23.2227V42.17H28.7827V36.61Z",
    fill: "#FFCF00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7827 36.61H23.2227V42.17H28.7827V36.61Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowingCapacity);
export default __webpack_public_path__ + "static/media/BorrowingCapacity.e01281bf898e0c7f303e782239bcfdda.svg";
export { ForwardRef as ReactComponent };